<template>
    <video-player  class="video-player-box"
                   ref="videoPlayer"
                   :options="playerOptions"
                   :playsinline="true">
    </video-player>
</template>

<script>
  import 'video.js/dist/video-js.css'
  import { videoPlayer } from 'vue-video-player'

  export default {
    name: 'VideoPlayer',
    components: {
      videoPlayer
    },
    props: ['src', 'extension'],
    data () {
      return {
        playerOptions: {
          width: '1000',
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: 'video/mp4',
            src: this.src
          }]
        }
      }
    },
    computed: {
      player () {
        return this.$refs.videoPlayer.player
      }
    }
  }
</script>

<style lang="scss">
    .video-js .vjs-big-play-button {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
